'use client';

import { useEventListener } from '@woonstad/helpers-hooks';
import { cn } from '@woonstad/helpers-utils';
import { useCallback, useRef, useState } from 'react';

import { CardLink } from '../box/CardLink';

type Props = {
  mainId?: string;
  label?: string;
}

export const SkipToContent = ({
  mainId = '#main',
  label = 'Naar hoofdcontent',
}: Props) => {
  const skipToContentRef = useRef<HTMLDivElement>(null);
  const [hasFocus, setHasFocus] = useState(false);

  const handleFocus = useCallback((e: FocusEvent) => setHasFocus(true), []);
  const handleBlur = useCallback(() => setHasFocus(false), []);

  useEventListener('focusin', handleFocus, skipToContentRef);
  useEventListener('focusout', handleBlur, skipToContentRef);

  return (
    <div
      ref={skipToContentRef}
      className={cn(
        'fixed -left-96 top-10 z-50',
        hasFocus && 'left-10',
      )}
    >
      <CardLink>
        <a
          href={mainId}
          tabIndex={0}
        >
          {label}
        </a>
      </CardLink>
    </div>
  );
};
